var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import * as Option from "fp-ts/lib/Option";
import { Env, config } from "core/utils";
import { Consent, ConsentCategory } from "core/privacy";
import CurartorFeed from "./CurartorFeed";
export var block = function (data) {
    return data.slug !== config.legoMasters.baseSlug
        ? Option.none
        : Option.some({
            key: "socialFeed",
            View: function () { return (React.createElement(Container, null, Env.isClient && (React.createElement(Consent, { category: ConsentCategory.SocialMedia },
                React.createElement(Content, null,
                    React.createElement(CurartorFeed, { id: config.legoMasters.curator.feedId, container: config.legoMasters.curator.containerId })))))); },
        });
};
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex-direction: column;\n  margin: 0;\n  width: 100%;\n"], ["\n  flex-direction: column;\n  margin: 0;\n  width: 100%;\n"])));
var Content = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  padding: 2.5rem 1.25rem;\n"], ["\n  width: 100%;\n  padding: 2.5rem 1.25rem;\n"])));
var templateObject_1, templateObject_2;
